import { render, staticRenderFns } from "./SucessoCriacaoEdicaoModal.vue?vue&type=template&id=10fcfe6c&"
import script from "./SucessoCriacaoEdicaoModal.vue?vue&type=script&lang=js&"
export * from "./SucessoCriacaoEdicaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports